type FolderMediaFile = {
  FolderId?: number | null;
};

/** Files that belong to the folder currently open in the media manager. */
export function mediaForFolder<T extends FolderMediaFile>(
  files: readonly T[] | null | undefined,
  folderId: number
): T[] {
  const list = files ?? [];
  if (folderId <= 0) {
    return [];
  }

  const tagged = list.some((file) => typeof file.FolderId === "number" && file.FolderId > 0);
  if (!tagged) {
    return [...list];
  }

  return list.filter((file) => file.FolderId === folderId);
}

/**
 * Result of a folder load. Null means this response lost the race to a later click.
 */
export function acceptFolderFiles<T extends FolderMediaFile>(
  requestId: number,
  currentRequestId: number,
  folderId: number,
  files: readonly T[] | null | undefined
): T[] | null {
  if (requestId !== currentRequestId) {
    return null;
  }

  return mediaForFolder(files, folderId);
}
